import Constants from '../constants';
import type { NotificationItem } from '../interfaces/notificationItem';

const urlUtils = {
  getUrl: (notification: NotificationItem) => {
    const { type } = notification;

    const urlMap = {
      [Constants.NOTIFICATION_TYPES.LEAD_ADDED]: () => {
        const { listingId = '', conversationId } = notification.payload;

        return `https://zillow.com/rental-manager/inbox/${listingId}/${conversationId}/?byProperty=true`;
      },
      [Constants.NOTIFICATION_TYPES.SYNDICATION_STATUS_UPDATED]: () => {
        const url: string | undefined = notification.payload.userPropertySyndicationBrandDto?.url;
        if (!url) {
          const { listingId } = notification.payload;
          return `https://zillow.com/rental-manager/properties/${listingId}/listing`;
        }
        return url;
      },
      [Constants.NOTIFICATION_TYPES.LISTING_EXPIRED]: () => {
        const { listingId } = notification.payload;

        return `https://zillow.com/rental-manager/properties/${listingId}/listing`;
      },
      [Constants.NOTIFICATION_TYPES.LISTING_NEARLY_EXPIRED]: () => {
        const { listingId } = notification.payload;

        return `https://zillow.com/rental-manager/properties/${listingId}/listing`;
      },
      [Constants.NOTIFICATION_TYPES.CONVERSATION_UPDATED]: () => {
        const { listingId, conversationId } = notification.payload;

        return `https://zillow.com/rental-manager/inbox/${listingId}/${conversationId}/?byProperty=true`;
      },
      [Constants.NOTIFICATION_TYPES.APPLICATION_RECEIVED]: () => {
        const { listingId, applicationId } = notification.payload;

        return `https://zillow.com/rental-manager/applications/${applicationId}?propertyId=${listingId}`;
      },
      [Constants.NOTIFICATION_TYPES.APPLICATION_UNREAD]: () => {
        const { listingId, applicationId } = notification.payload;

        return `https://zillow.com/rental-manager/applications/${applicationId}?propertyId=${listingId}`;
      },
      [Constants.NOTIFICATION_TYPES.APPLICATION_WITHDRAWN]: () => {
        const { listingId } = notification.payload;

        return `https://zillow.com/rental-manager/applications?propertyId=${listingId}`;
      },
      [Constants.NOTIFICATION_TYPES.CUSTOMER_LISTING_PROBLEM]: () => {
        const { listingId = '' } = notification.payload;

        if (listingId.length > 0) {
          return `https://zillow.com/rental-manager/properties/${listingId}/listing`;
        }

        return `https://zillow.com/rental-manager/properties?subNavFilterType=at-risk`;
      },
      [Constants.NOTIFICATION_TYPES.NEW_UPDATED_INVOICE]: () => {
        return `https://www.zillow.com/rental-manager/billing/due`;
      },
      [Constants.NOTIFICATION_TYPES.USER_MANAGEMENT_INVITATION]: () => {
        return `https://www.zillow.com/rental-manager/user-management/invitation`;
      },
      [Constants.NOTIFICATION_TYPES.REVIEW_CREATED]: () => {
        const { listingId } = notification.payload;

        return `https://zillow.com/rental-manager/properties/${listingId}/reviews`;
      },
      [Constants.NOTIFICATION_TYPES.DRAFT_REMINDER]: () => {
        const { listingId } = notification.payload;

        return `https://zillow.com/rental-manager/properties/${listingId}/listing`;
      },
      [Constants.NOTIFICATION_TYPES.ENTERPRISE_LISTING_DECLINED]: () => {
        const { listingId } = notification.payload;

        return `https://zillow.com/rental-manager/properties/${listingId}/listing`;
      },
    };

    return urlMap[type]();
  },
  getNotficationEndpoints: () => Constants.NOTIFICATION_CENTER_ENDPOINTS,
};

export default urlUtils;
